














import Vue from "vue";
import Component from "vue-class-component";
import ChevronDoubleRightIcon from "vue-material-design-icons/ChevronDoubleRight.vue";
import RdStation from "@/plugins/RdStation";
import ApiSimulador from "@/plugins/ApiSimulador";

@Component({
    components: { ChevronDoubleRightIcon }
})
export default class DadosProsseguir extends Vue {

    get loadingFipe () {
        return this.$store.state.loading_fipe;
    }

    get origemSite () {
        return !this.cotacao.origem_fipe;
    }

    get cotacao () {
        return this.$store.state.cotacao;
    }

    get email() {
        return this.$store.getters.get_email;
    }

    get dddTelefone () {
        return `${this.cotacao.ddd}${this.cotacao.telefone}`;
    }

    get dados() {
        return this.$store.getters.cotacao;
    }

    public onClick () {
        this.$store.dispatch("VALIDAR_DADOS", true)
            .then(() => {
                this.$router.push({
                  name: 'complemento'
                }).then();
                if ( this.$store.state.cotacao.id === undefined ) {
                    ApiSimulador.create(this.dados).then(( data ) => {
                        this.$store.commit("SET_ID", data.id);
                        this.$store.commit("SET_PROTOCOLO", data.protocolo);
                        this.conversaoPrincipal("Protruck - Simulador site", data);
                    });
                }

                window.fbq('track', 'Lead');
                window.fbq('track', 'AddToCart', {
                    value:    this.$store.getters.valor_mensalidade,
                    currency: 'BRL',
                });

        }).catch(() => { return; });

    }

    public conversaoPrincipal( identificador: string, data: any ) {
        RdStation.conversion({
            "nome": this.cotacao.nome,
            "email": this.email,
            "identificador": identificador,
            "telefone": this.dddTelefone,
            "celular": this.dddTelefone,

            "Tipo de veículo": "Caminhão",
            "Marca": this.cotacao.marca,
            "Veículo": this.cotacao.modelo,
            "Modelo": this.$store.getters.veiculo_ano,
            "Preço do Veículo": this.cotacao.valor_fipe,
            "Mensalidade teto": this.$store.getters.valor_mensalidade,

            "Link proposta": `https://prote.me/${data.protocolo}`,
            "id_proposta": data.id,
        }).then();
    }
}
